import React, { useState } from "react";
import {
  SaveButton,
  useUpdate,
  useNotify,
  FormWithRedirect,
  useTranslate,
  useRefresh,
  useRedirect,
} from "react-admin";
import { Flex, Text } from "rebass";
import { Button } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import IconCancel from "@material-ui/icons/Cancel";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import FormFieldCountries from "./FormFieldCountries";
import { useWindowSize } from "../../../components";
import CloseIcon from "@material-ui/icons/Close";
import { EditIcon } from "../../../components/icon_svg";

function EditCountries(props) {
  const { record } = props;
  const refresh = useRefresh();
  const redirect = useRedirect();
  const windowSize = useWindowSize();
  const translate = useTranslate();
  const [showDialog, setShowDialog] = useState(false);
  const [update, { loading }] = useUpdate("countries");
  const notify = useNotify();
  // const form = useForm()

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowDialog(open);
  };

  const handleSubmit = async (values) => {
    update(
      { payload: { id: record.id, data: values } },
      {
        onSuccess: ({ data }) => {
          // Update the comment form to target the newly created post
          // Updating the ReferenceInput value will force it to reload the available posts
          // form.change("id", data.id)
          setShowDialog(false);
          redirect("/codes/countries");
          notify("resources.notification.updated");
          refresh();
        },
        onFailure: ({ error }) => {
          notify(error.message, "error");
        },
      }
    );
  };
  return (
    <>
      <IconButton onClick={toggleDrawer(true)} size="small" color={"primary"}>
        <EditIcon size="small" style={{ width: "1rem", height: "1rem" }} />
      </IconButton>
      <SwipeableDrawer
        anchor={"right"}
        open={showDialog}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <Flex width={[`${windowSize.width - 50}px`]} flexDirection={"column"}>
          <Flex
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            p={[2]}
          >
            <Text fontSize={[3]} fontWeight={"bold"} ml={[3]}>
              {translate("resources.settings.labels.edit_country")}
            </Text>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Flex>
          <FormWithRedirect
            resource="countries"
            save={handleSubmit}
            initialValues={record}
            render={({ handleSubmitWithRedirect, pristine, saving }) => (
              <Flex flexDirection={"column"} width={[1]} p={[2]}>
                <FormFieldCountries {...props} translate={translate} />
                <Flex
                  width={[1]}
                  flexDirection={"row"}
                  sx={{
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                  }}
                >
                  <Flex
                    width={[1]}
                    flexDirection={"row"}
                    justifyContent="flex-end"
                  >
                    <Button
                      onClick={toggleDrawer(false)}
                      color="primary"
                      style={{ textTransform: "capitalize", marginRight: 8 }}
                      startIcon={<IconCancel />}
                    >
                      {translate("ra.action.cancel")}
                    </Button>
                    <SaveButton
                      handleSubmitWithRedirect={handleSubmitWithRedirect}
                      pristine={pristine}
                      saving={saving}
                      disabled={loading}
                    />
                  </Flex>
                </Flex>
              </Flex>
            )}
          />
        </Flex>
      </SwipeableDrawer>
    </>
  );
}

export default EditCountries;
